module.exports = __webpack_public_path__ + "static/media/logo.47916961.png";